import { Popover } from "@mui/material";
import { styled } from "@mui/material/styles";
import variableStyles from "../../theme/variable-styles";
import { responsiveFontSizes } from "../../utils/responsive";
import { BorderRight, Padding } from "@mui/icons-material";

interface SidebarWrapperProps {
  notexpanded: boolean;
}

export const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden"
});

export const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingLeft: "300px",
  transition: "all 0.5s ease-in-out",
  paddingBottom: theme.spacing(10),
  backgroundColor: theme.palette.background.default
}));

export const SidebarWrapper = styled("div")<SidebarWrapperProps>(
  ({ theme, notexpanded }) => ({
    flex: "0 0 auto",
    position: "relative",
    color: "#596970",
    backgroundColor: variableStyles.MainColor,
    borderRight: `1px solid #EDEDED`,
    // borderTop: `1px solid #EDEDED`,
    borderRadius: "0 10px 10px 0",
    //paddingRight: "1rem",
    // borderRight: `1px solid ${variableStyles.NaturalColor200}`,
    "@keyframes hidden": {
      "0%": {
        opacity: "1"
      },
      "50%": {
        opacity: "1"
      },
      "100%": {
        display: "none",
        opacity: "0"
      }
    },
    "& .workflow-management-active": {
      display: "flex",
      minWidth: "35px",
      alignItems: "center",
      borderRadius: "6px",
      marginBottom: "0px",
      backgroundColor: "#0A3170",
      color: "#ffffff",
      "& h6": {
        color: "#ffffff"
      },
      "& img": {
        filter: "brightness(0) invert(1)"
      },
    },
    "& .summary-active": {
      display: "flex",
      minWidth: "35px",
      alignItems: "center",
      borderRadius: "6px",
      marginBottom: "0px",
      backgroundColor: "#0A3170",
      color: "#ffffff",
      "& h6": {
        color: "#ffffff"
      },
      "& img": {
        filter: "brightness(0) invert(1)"
      }
    },
    "& .sidebar-box": {
      // width: notexpanded ? "64px" : "290px",
      width: notexpanded ? "64px" : "300px",
      //backgroundColor: notexpanded ? "#3091F3" : "#f1f5f6",
      transition: "all 0.25s linear"
      // height: "calc(100vh - 52px)"
      // overflow: "auto"
    },
    "& a:hover": {
      cursor: "pointer"
    },
    "& .sidebar-box-expanded": {
      gap: "8px",
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "25px 20px",
      backgroundColor: '#0A3170'
    },
    "& .sidebar-box-not-expanded": {
      flexDirection: "column",
      '& .expanded-button': {
        transform: "rotate(180deg)"
      }
    },
    "& .expanded-button": {
      position: "absolute",
      top: "64px",
      right: "-14px",
      // bottom: "20px",
      // right: "20px",
      width: "28px !important",
      height: "28px !important",
      borderRadius: "4px",
      border: `0.5px solid ${variableStyles.NaturalColor200}`,
      zIndex: "2",
      // backgroundColor: "#ffffff",
      backgroundColor: "#0a3f95 !important",
      "&:hover": { backgroundColor: "#ffffff" },
      boxShadow: "0px 21px 37px -15px #1956580F",
      "& img": { transition: "all 0.25s linear" },
      "&.notExpanded": {
        "& img": { transform: "rotate(180deg)" }
      }
    },
    "& .project-infor-wrapper": {
      padding: "12px 10px 4px",
      marginBottom: "24px",
      display: "flex",
      justifyContent: "center",
      "& .project-infor": {
        width: "100%",
        justifyContent: "space-between",
        padding: "8px 4px",
        borderRadius: "10px",
        "&:hover, &.active": {
          backgroundColor: variableStyles.MainColor
        },
        "& .infor-box": {
          display: "flex",
          gap: "12px",
          alignItems: "center",
          flex: "1 1 auto",
          "& .project-avatar": {
            flex: "0 0 auto"
          },
          "& .project-name": {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "4px",
            flex: "1 1 auto",
            maxWidth: "136px",
            "& .name-project": {
              color: variableStyles.NaturalColor950,
              fontWeight: variableStyles.fwSemiBold,
              fontSize: "14px",
              lineHeight: "14px",
              width: "max-content",
              maxWidth: "100%",
              textAlign: "left"
            },
            "& .name-domain": {
              color: variableStyles.NaturalColor900,
              fontWeight: variableStyles.fwRegular,
              fontSize: "12px",
              lineHeight: "12px",
              width: "max-content",
              maxWidth: "100%",
              textAlign: "left"
            }
          }
        },
        "&.notExpanded": {
          "& .project-name, & img.arrow-right": {
            animation: "hidden .2s linear forwards"
          }
        },
        "& .arrow-right": {
          transform: "rotate(180deg)"
        }
      },
      "& .create-project-button": {
        width: "100%",
        margin: "8px 0",
        minWidth: "0",
        boxShadow: "none",
        "& p": { minWidth: "max-content" },
        "&.notExpanded": {
          width: "36px",
          "& p": { animation: "hidden .2s linear forwards" }
        }
      }
    },

    "& .sidebar-menu": {
      // height: "calc(100vh - 64px - 40px - 1rem - 100px)",
      // overflow: "auto",
      "&.notExpanded": {
        transition: "all 0s linear 0.2s",
        height: "calc(100vh - 222px)"
      },
      "& .sidebar-item": {
        marginBottom: "24px",
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          width: "24px",
          height: "1px",
          top: "6px",
          left: "calc(50% - 12px)",
          backgroundColor: variableStyles.NaturalColor300,
          transition: "all 0.2s linear",
          transform: "scaleX(0)",
          opacity: 0
        },
        "&.notExpanded": {
          "&::after": {
            transform: "scaleX(1) !important",
            opacity: 1
          }
        },
        "& .sidebar-title": {
          color: "#2D393E",
          fontWeight: variableStyles.fwBold,
          fontSize: "13px",
          lineHeight: "12px",
          padding: "0 16px",
          marginBottom: "12px",
          transition: "all 0.2s linear",
          transform: "scaleX(1)",
          opacity: 1,
          height: "12px",
          "&.notExpanded": {
            transform: "scaleX(0)",
            opacity: 0,
            height: "12px"
          }
        }
      },
      "& .sidebar-children": {
        alignItems: "end",
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        marginTop: "12px",
        "& .children-item": {
          width: "100%",
          // padding: "8px 16px",b
          paddingLeft: "34px",
          position: "relative",
          borderRadius: "6px",
          // "&::before": {
          //   content: '""',
          //   width: "0",
          //   height: "24px",
          //   position: "absolute",
          //   top: "calc(50% - 12px)",
          //   left: "0",
          //   backgroundColor: notexpanded ? "white" : "#3091F3",
          //   borderRadius: "0 12px 12px 0",
          //   transition: "all 0.2s linear"
          // },
          "& button": {
            zIndex: 100,
            // backgroundColor: "transparent",
            padding: "8px 16px",
            width: "100%",
            // color: "#7B7B7B",
            color: "rgba(255, 255, 255, 0.5)",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            borderRadius: "6px",
            transition: "all 0.2s linear",
            position: "relative",
            // "& span": {
            //   display: "none"
            // },
            "& p": {
              textTransform: "capitalize",
              fontSize: "14px",
              fontWeight: "500",
              transition: "all 0.2s linear",
              position: "relative",
              display: "-webkit-box",
              "-webkit-box-orient": "vertical",
              "-webkit-line-clamp": "1",
              overflow: "hidden",
              // color: "#7B7B7B",
              color: "rgba(255, 255, 255, 0.5)",
              textAlign: "left",
              "&.notExpanded": { animation: "hidden .2s linear forwards" },
            },
            "&:hover": {
              "& p": {
                color: "#7B7B7B",
                fontWeight: 700
              }
              // backgroundColor: variableStyles.NaturalColor200
            },
            "&:focus": {
              outline: "none"
            },
            "& .icon-box": {
              width: "20px",
              height: "20px",
              position: "relative",
              overflow: "hidden",
              flex: "0 0 auto",
              "& img": {
                position: "absolute",
                top: "0",
                left: "0",
                transition: "all 0.2s linear",
                "&.box-default": {
                  zIndex: 1,
                  transform: "scaleX(1)",
                  "&.active": { zIndex: 0, transform: "scaleX(0)" }
                },
                "&.box-active": {
                  zIndex: 0,
                  transform: "scaleX(0)",
                  "&.active": { zIndex: 1, transform: "scaleX(1)" }
                }
              }
            }
          },
          "&::after": {
            width: "24px"
          },
          "&.active": {
            "&::before": {
              width: "5px"
            },
            "&::after": {
              width: "12px"
            },
            "& button": {
              // backgroundColor: "#04214D",
              backgroundColor: "#0A3170",
              padding: "8px 16px",

              // width: "100%",
              // height: "38px",
              //boxShadow: "0px 2px 3.5px 0px #0000000A",
              //backgroundColor: variableStyles.NaturalColor0,
              "& p": {
                color: "#ffffff",
                // fontWeight: variableStyles.fwSemiBold,
              }
            }
          }
        },
        "& .children-item-notexpanded": {
          padding: "0.4rem 0",
          position: "relative",
          textAlign: "center",
          // "&::before": {
          //   content: '""',
          //   width: "0",
          //   height: "24px",
          //   position: "absolute",
          //   top: "calc(50% - 12px)",
          //   left: "0",
          //   backgroundColor: notexpanded ? "white" : "#3091F3",
          //   borderRadius: "0 12px 12px 0",
          //   transition: "all 0.2s linear"
          // },

          "& button": {
            color: "#2D393E",
            display: "inline-block",
            justifyContent: "flex-start",
            alignItems: "center",
            //padding: "9px",
            borderRadius: "8px",
            transition: "all 0.2s linear",
            position: "relative",
            "& p": {
              //fontWeight: variableStyles.fwMedium,
              fontSize: "13px",
              lineHeight: "15px",
              transition: "all 0.2s linear",
              position: "relative",
              minWidth: "max-content",
              color: "#596970",
              "&.notExpanded": { animation: "hidden .2s linear forwards" }
            },
            "&:hover": {
              "& p": {
                color: "#3091F3",
                fontWeight: 700
              }
              // backgroundColor: variableStyles.NaturalColor200
            },
            "&:focus": {
              outline: "none"
            },
            "& span": {
              margin: 0
            },
            "& .icon-box": {
              width: "20px",
              height: "20px",
              position: "relative",
              overflow: "hidden",
              flex: "0 0 auto",
              "& img": {
                position: "absolute",
                top: "0",
                left: "0",
                transition: "all 0.2s linear",
                "&.box-default": {
                  zIndex: 1,
                  transform: "scaleX(1)",
                  "&.active": { zIndex: 0, transform: "scaleX(0)" }
                },
                "&.box-active": {
                  zIndex: 0,
                  transform: "scaleX(0)",
                  "&.active": { zIndex: 1, transform: "scaleX(1)" }
                }
              }
            }
          },

          "&.active": {
            "&::before": {
              width: "5px"
            },
            "& button": {
              // width: "100%",
              // height: "38px",
              //boxShadow: "0px 2px 3.5px 0px #0000000A",
              //backgroundColor: variableStyles.NaturalColor0,
              "& p": {
                color: "#3091F3",
                // fontWeight: variableStyles.fwSemiBold,
                fontSize: "13px"
              }
            }
          }
        }
      }
    },
    "& .plan-box-wrapper": {
      padding: "14px",
      transition: "all 0.2s linear",
      position: "relative",
      minHeight: "78px",
      "& .plan-box": {
        transform: "scaleX(1)",
        minWidth: "max-content"
      },
      "&.notExpanded .plan-box": {
        animation: "hidden .2s linear forwards"
      },
      "& .not-expanded-button": {
        transition: "all 0.2s linear",
        position: "absolute",
        bottom: "27px",
        left: "14px",
        minWidth: "unset",
        transform: "scaleX(0)",
        opacity: 0,
        backgroundColor: variableStyles.NaturalColor0,
        border: `1px solid ${variableStyles.blueSecondary300}`,
        "&:hover": { backgroundColor: "#ffffff" }
      },
      "&.notExpanded .not-expanded-button": {
        animation: "showButtonPlanBox .2s linear forwards"
      },
      "@keyframes showButtonPlanBox": {
        "0%": {
          transform: "scaleX(0)",
          opacity: 0
        },
        "50%": {
          transform: "scaleX(1)",
          opacity: 1
        },
        "100%": {
          transform: "scaleX(1)",
          opacity: 1
        }
      }
    }
  })
);

export const NavbarWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  backgroundColor: variableStyles.GreenPrimaryColor950,
  padding: "6px 12px",
  position: "relative",
  "& .header-navigate": {
    display: "flex",
    gap: "36px",
    alignItems: "center",
    "& .header-menu": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "32px",
      "& .menu-item": {
        paddingBottom: "3px",
        "& a": {
          color: variableStyles.NaturalColor300,
          fontWeight: variableStyles.fwSemiBold,
          fontSize: "12px",
          lineHeight: "15px",
          transition: "all 0.2s ease-out",
          "&:hover": {
            color: variableStyles.NaturalColor50
          }
        }
      }
    }
  },
  "& .header-action": {
    display: "flex",
    alignItems: "center",
    "& .action-search": {
      marginRight: "12px",
      flex: "0 0 auto",
      width: "200px"
    },
    "& .actice-group": {
      display: "flex",
      alignItems: "center",
      marginRight: "8px",
      gap: "8px",
      flex: "0 0 auto",
      "& button": {
        padding: "6px",
        opacity: ".5",
        transition: "all 0.2s ease-out",
        "&:hover": {
          opacity: "1"
        }
      }
    },
    "& .action-profile": {
      flex: "0 0 auto",
      padding: "4px"
    }
  }
}));

export const PlanPopoverWrapper = styled(Popover)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "12px",
    marginLeft: "14px"
  }
}));

export const ActionPopoverWrapper = styled(Popover)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "12px",
    marginTop: "18px",
    padding: "12px 8px",
    border: `1px solid ${variableStyles.NaturalColor100}`,
    boxShadow: "0px 21px 37px -15px #1956580F",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "auto",
    height: "auto",
    maxWidth: "390px",
    maxHeight: "60vh",
    "& .MuiDivider-root": {
      borderColor: variableStyles.NaturalColor200
    },
    "& .profile-infor": {
      display: "flex",
      gap: "12px",
      "& .detail-name": {
        color: variableStyles.NaturalColor950,
        fontWeight: variableStyles.fwSemiBold,
        fontSize: "14px",
        lineHeight: "14px",
        marginBottom: "4px"
      },
      "& .detail-email": {
        color: variableStyles.NaturalColor900,
        fontWeight: variableStyles.fwRegular,
        fontSize: "12px",
        lineHeight: "12px"
      }
    },
    "& .profile-actions": {
      "& li": {
        "& a": {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: variableStyles.NaturalColor900,
          fontWeight: variableStyles.fwRegular,
          fontSize: "14px",
          lineHeight: "14px",
          padding: "10px 6px",
          borderRadius: "6px",
          transition: "all .2s linear",
          "&:hover": {
            backgroundColor: variableStyles.NaturalColor100
          }
        }
      }
    },
    "& .profile-plan": {
      display: "flex",
      justifyContent: "space-between",
      padding: "2px 6px",
      alignItems: "center",
      "& .infor-title": {
        color: variableStyles.NaturalColor950,
        fontWeight: variableStyles.fwSemiBold,
        fontSize: "14px",
        lineHeight: "14px",
        marginBottom: "6px"
      },
      "& .infor-description": {
        color: variableStyles.NaturalColor600,
        fontWeight: variableStyles.fwMedium,
        fontSize: "12px",
        lineHeight: "12px"
      },
      "& button": {
        padding: "9px 18px"
      }
    },
    "& .profile-logout": {
      gap: "8px",
      color: variableStyles.Error500,
      fontWeight: variableStyles.fwSemiBold,
      fontSize: "14px",
      lineHeight: "14px",
      padding: "6px",
      width: "100%",
      justifyContent: "flex-start",
      borderRadius: "6px",
      "&:hover": {
        color: `${variableStyles.Error500} !important`,
        backgroundColor: variableStyles.Error50
      }
    }
  }
}));

export const ProjectPopoverWrapper = styled(Popover)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "12px",
    marginLeft: "28px",
    border: `1px solid ${variableStyles.NaturalColor100}`,
    padding: "12px 8px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "238px",
    "& .project-list": {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      "& li": {
        "& a": {
          borderRadius: "12px",
          padding: "6px",
          display: "flex",
          alignItems: "center",
          transition: "all 0.2s linear",
          "&:hover": {
            backgroundColor: variableStyles.NaturalColor100
          },
          "& .infor-box": {
            display: "flex",
            gap: "12px",
            alignItems: "center",
            width: "222px",
            "& .project-avatar": {
              flex: "0 0 auto"
            },
            "& .project-name": {
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: "4px",
              flex: "1 1 auto",
              "& .name-project": {
                color: variableStyles.NaturalColor950,
                fontWeight: variableStyles.fwSemiBold,
                fontSize: "14px",
                lineHeight: "14px"
              },
              "& .name-domain": {
                color: variableStyles.NaturalColor900,
                fontWeight: variableStyles.fwRegular,
                fontSize: "12px",
                lineHeight: "12px"
              }
            }
          }
        }
      }
    },
    "& .MuiDivider-root": {
      borderColor: variableStyles.NaturalColor200
    },
    "& .create-button": {
      gap: "8px"
    }
  }
}));

export const NotificationWrapper = styled("div")(() => ({
  minWidth: "300px",
  "@media (max-width: 868px)": {
    "& .check-svg": { width: "16px", height: "16px" },
    "& .title": {
      ...responsiveFontSizes({
        fontsize: {
          xs: 16,
          sm: 16,
          md: 18,
          lg: 20,
          xl: 20
        },
        lineheight: {
          xs: 22.59,
          sm: 22.59,
          md: 22.59,
          lg: 22.59,
          xl: 22.59
        }
      })
    },
    "& .date-time": {
      ...responsiveFontSizes({
        fontsize: {
          xs: 12,
          sm: 14,
          md: 16,
          lg: 16,
          xl: 16
        },
        lineheight: {
          xs: 22.59,
          sm: 22.59,
          md: 22.59,
          lg: 22.59,
          xl: 22.59
        }
      })
    }
  }
}));

export const SidebarGroupPanelWrapper = styled("div")(theme => ({
  "& .MuiDivider-root": {
    marginLeft: 0,
    overflow: "hidden"
  },
  "& .MuiPaper-root": {
    backgroundColor: "transparent",
    "& .Mui-expanded": { margin: 0 },
    "& .MuiAccordionSummary-root": {
      padding: 0,
      minHeight: "40px",
      flexDirection: "row-reverse",
      "& MuiAccordionSummary-content": {
        margin: 0
      }
    },
    "& .MuiAccordionDetails-root": {
      // padding: " 8px 8px 24px",
      margin: 0,
      padding: 0,
      "& .workflow-item": {
        minWidth: 280
        // height: 184
      }
    },
    "& .group-panel-title": {
      alignSelf: "center",
      fontWeight: 600,
      paddingLeft: ".5em",
      color: "#596970"
    }
  }
}));
